import React from "react";
import { Path } from "paths";
import {
  ResourceList,
  ResourceInsights,
  CreateResource,
  EditResource,
  SectionList,
  CreateSection,
  EditSection,
  ResourceTypeList,
  CreateResourceType,
  EditResourceType,
} from "modules";
import { RouteRender } from "components/commons";

const ResourceManagementPage = () => {
  return (
    <RouteRender
      defaultRedirect={Path.RESOURCE}
      renders={{
        // Resource routes
        
        [Path.RESOURCE_CREATE]: {
          exact: true,
          component: CreateResource,
        },
        [Path.RESOURCE_EDIT]: {
          exact: true,
          component: EditResource,
        },
        // Section routes
        [Path.SECTION]: {
          exact: true,
          component: SectionList,
        },
        [Path.SECTION_CREATE]: {
          exact: true,
          component: CreateSection,
        },
        [Path.SECTION_EDIT]: {
          exact: true,
          component: EditSection,
        },
        // ResourceType routes
        [Path.RESOURCETYPE]: {
          exact: true,
          component: ResourceTypeList,
        },
        [Path.RESOURCETYPE_CREATE]: {
          exact: true,
          component: CreateResourceType,
        },
        [Path.RESOURCETYPE_EDIT]: {
          exact: true,
          component: EditResourceType,
        },
        [Path.RESOURCE]: {
          exact: true,
          component: ResourceList,
        },
        [Path.RESOURCE_INSIGHTS]: {
          exact: true,
          component: ResourceInsights,
        },
      }}
    />
  );
};

export default ResourceManagementPage;
